import Image from "next/image";
import cookieImage from "../../../../public/static/images/enablecookies.svg";
import styles from "./AppBlocked.module.scss";

export const AppBlockedComponent = () => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className={styles.not_found}>
      <div className={styles.not_found_header}>
        <h2 className="main_title">Enable Cookies</h2>
        <p className="sub_title">
          Sorry we couldn&apos;t access the app. Please enable your browser
          cookies.
        </p>
      </div>
      <div className={styles.not_found_img}>
        <Image
          src={cookieImage}
          alt="Enable cookies"
          style={{ width: "100%", height: "auto" }}
        />
      </div>

      <button className={styles.return_home} onClick={reloadPage}>
        Go to Homepage
      </button>
    </div>
  );
};
